import { EPButton } from '@/components';
import { useStores } from '@/hooks/use-stores';
import { Tooltip, message } from 'antd';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { getLastUpdatedInfo } from './PIDEditing.utils';

const EditModeMenu = observer(() => {
  const { pidEditStore } = useStores();
  const { lastActivatedUserInfo } = pidEditStore;
  const { t } = useTranslation();

  const handleEditMode = async () => {
    try {
      await pidEditStore.lockStationDraft();
      pidEditStore.toggleEditMode(true);
      pidEditStore.setIsInEditMode(true);
    } catch (error) {
      message.error(`Failed to enter edit mode: ${error.message || JSON.stringify(error)}`);
    }
  };

  return (
    !pidEditStore.isEditModeEnabled && (
      <Tooltip
        title={getLastUpdatedInfo(lastActivatedUserInfo, t)}
        placement="left"
        color="blue"
        styles={{ root: { maxWidth: 'fit-content' } }}
      >
        <EPButton onClick={handleEditMode}>{t('Edit Map')}</EPButton>
      </Tooltip>
    )
  );
});

export default EditModeMenu;
